module.exports = __webpack_public_path__ + "static/Loews-Logo-new-be8828982574ba3755393e0abd4c16e1.png";